<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Pagination from "@/components/standard/hazardIdentification/hazardPagination2";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification";
import CheckModal from "@/components/CheckModal";
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import DontExist from "@/components/company/components/DontExist";
import revisionAnualAPI from "../../../services/standards/revisionAnual/revisionAnualAPI";
import politicaAlcoholDrogasAPI from "../../../services/standards/politicaAlcoholDrogas/politicaAlcoholDrogasAPI";
import PoliticaAlcoholDrogasPagination from "../../../components/standard/politicaAlcoholDrogas/PoliticaAlcoholDrogasPagination.vue";
/**
 * Form elements component
 */
export default {
  page: {
    title: "Política de No alcohol y drogas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
    DontExist,
    PoliticaAlcoholDrogasPagination,
  },
  data() {
    return {
      title: "Política de No alcohol y drogas",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Estilo de vida y entornos saludables",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id || null
            }/estilo-vida`,
        },
        {
          text: "Política de No alcohol y drogas",
          active: true,
        },
      ],

      lista: [],
      file: null,
      loading: true,
      acta: null,

      item: null,
      itemStatus: null,
      search: "",
      lastId: 1,
      submitted: false,

      itemData: null,

      politica: {
        file: "datos",
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(29)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goPage(page) {
      window.location.href = page;
    },

    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 29)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status ? response.status : null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(item, itemStatus) {
      if (item) {
        const itemChange = {
          items_id: item.items_id,
          status: itemStatus,
          operation: item.operation,
          puntation_absoluta: item.puntation_absoluta,
          puntation_relative: item.puntation_relative,
        };
        CompanyItemsAPI.updateStatus(this.companyID, itemChange)
          .then((response) => {
            if (
              response.message ===
              "item actualizado con exito, se ha sumado el valor del item , en la puntuacion" ||
              response.message === "item actualizado con exito" ||
              response.message ===
              "item actualizado con exito, se ha descontado el valor del item , en la puntuacion"
            ) {
              setTimeout(() => {
                Swal.fire({
                  title: "¡Se ha actualizado el estado del ítem con éxito!",
                  type: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
            } else {
              Swal.fire({
                title: "No se ha podido actualizar el estado del ítem",
                type: "warning",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    /**
     * Method to know the status item.
     * @param {Number} - Item ID.
     * @param {Object} - Item to get.
     * @param {Number} -  Status item.
     */
    getStatusItem(ID, item, itemStatus) {
      CompanyItemsAPI.getStatus(this.companyID, ID)
        .then((response) => {
          item = response || null;
          itemStatus = response.status;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.1.7/politica_alcohol_drogas/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/3.1.7/politica_alcohol_drogas/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.politica.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getList() {
      politicaAlcoholDrogasAPI
        .getPolitica(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.loading = false;
          let identification = response.data.data;
          this.lista = identification;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getLastId() {
      politicaAlcoholDrogasAPI.getAll(this.$store.getters["company/getCompany"].id,'','')
        .then((response) => {
          if (response.data.data[0]['id']) {
            this.lastId = response.data.data[0]['id'] + 1
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async save() {
      this.submitted = true;
      this.loading = true
      let response = await this.uploadDocument();
      if (response) {
        politicaAlcoholDrogasAPI
          .save(this.politica)
          .then((response) => {
            if (response.message === "Exito, politica creada!") {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "¡Se ha registrado con éxito!",
                  type: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
            } else if (
              response.message ===
              "Esta Empresa ya posee un registro de este item 6.1.3 Revisión anual por la Alta Dirección, resultados y alcance de la auditoría en estatus de PENDIENTE, o APROBADO, Actualice el registro anterior a NO CUMPLIDO para realizar uno nuevo"
            ) {
              Swal.fire({
                title:
                  "Esta Empresa ya posee un registro de este item 6.1.3 Revisión anual por la Alta Dirección, resultados y alcance de la auditoría en estatus de PENDIENTE, o APROBADO, Actualice el registro anterior a NO CUMPLIDO para realizar uno nuevo",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
            }
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡No se ha podido registrar!",
            type: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    deletePolitica(id) {
      politicaAlcoholDrogasAPI
        .delete(id)
        .then((data) => {
          Swal.fire({
            title: "Se ha sido eliminado con exito!",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getActa() {
      revisionAnualAPI
        .getActa()
        .then((response) => {
          this.acta = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },
  },

  mounted() {
    this.getActa();
    this.getItems();
    this.getList();
    this.getLastId();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading && classificationID <= 4">
          <div class="card">
            <div class="card-body">
              <div class="row px-2">
                <div class="col-md-12">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa debe elaborar y ejecutar un programa para
                      promover entre los trabajadores, estilos de vida y
                      entornos de trabajo saludable, incluyendo campañas
                      específicas tendientes a la prevención y el control de la
                      fármaco dependencia, el alcoholismo y el tabaquismo, entre
                      otros.
                    </p>
                    <p class="text-justify">
                      En este ítem se podrá descargar un modelo de política para
                      la prevención y control del consumo de alcohol y
                      sustancias psicoactivas, además se deberá elaborar el
                      cronograma de las actividades relacionadas con el tema y
                      posteriormente subir las evidencias de su ejecución.
                    </p>
                  </CheckModal>
                </div>
              </div>

              <hr />

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-12 px-3" label="Política de No alcohol y drogas" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" required type="file" id="file" ref="file"
                      name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 px-2 pt-2">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form @submit.prevent="fetch()" class="form-inline">
                            <div class="form-group mr-2">
                              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                class="form-control px-2" placeholder="Buscar"></b-form-input>

                              <div class="col-1">
                                <button type="submit" class="btn btn-primary px-2">
                                  Buscar
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">Fecha</th>
                              <th class="text-center align-middle">
                                Documento
                              </th>
                              <th class="text-center align-middle">
                                Ver archivo
                              </th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td class="text-center align-middle">
                                {{ dateConvert(dato.created_at) }}
                              </td>
                              <td class="text-center align-middle">
                                Política de No alcohol y drogas
                              </td>
                              <td class="text-center align-middle">
                                <div v-if="dato.file === null">
                                  <h6>No hay archivo disponible</h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()" style="
                                      background-color: transparent !important;
                                      border: none;
                                    " type="button" @click="gotoDigitalOcean(`${dato.file}`)">
                                    <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                      " :to="{
    path: `/forms/estandares/politica-alcohol-drogas-editar/${dato.id}`,
  }">Editar</b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                      " v-on:click="deletePolitica(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <PoliticaAlcoholDrogasPagination ref="paginator" :search="search"
                          @fetch="(items) => (lista = items)" />
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else-if="!loading && classificationID > 3">
          <DontExist />
        </div>

        <div v-else-if="!loading">
          <DontExist />
        </div>
        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
